import React from 'react';
import { Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { GetDateFormat } from '../../lib/date';
import { InputDateTime } from '../../lib/forms';

let InputRadioWithFieldFreeze = ({ input, values, min, radioName, activeDate, label, option1, translate, hasFuture, meta: { touched, error } }) => {
  const notChange = hasFuture ?
    <label className="custom-control custom-radio">
      <input {...input} className="custom-control-input" type="radio" name={radioName} value={ activeDate === null ? "option1" : activeDate } />
      <span className="custom-control-indicator"></span>
      <span className="custom-control-description">{`${translate('do-not-change')} (${activeDate === null ? translate('without-stopping') : GetDateFormat(activeDate)})`}</span>
    </label>
    :
    '';
  return (
    <div className="form-group row">

      <div className="col">
        {touched && error && <div>
          <span className="text-danger">{error}</span></div>}
        <div className="custom-controls">
          {notChange}
          <label className="custom-control  custom-radio">
              <input {...input} className="custom-control-input" type="radio" name={radioName} value="option1"/>
              <span className="custom-control-indicator"></span>
              <span className="custom-control-description">{option1}</span>
            </label>
            <label className="custom-control custom-radio col-sm-row">
              <input {...input} className="custom-control-input" type="radio" name={radioName} value="option2"/>
              <span className="custom-control-indicator custom-control-indicator-center"></span>
              <span className="">
                <Field  placeholder={translate('select-date')}  radioName={radioName} label="nom" className="form-control" values={values} component={InputDateTime} min={min} name={`${radioName}Field`} type="date" />
              </span>
            </label>
        </div>
      </div>
    </div>

  );
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    values: getFormValues('Freeze')(state) ||{},
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

InputRadioWithFieldFreeze = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InputRadioWithFieldFreeze);

export default InputRadioWithFieldFreeze;



// WEBPACK FOOTER //
// ./src/components/Freeze/InputRadioWithFieldFreeze.js